<ax-image-source [source]="source" [actualSize]="true">
  <ax-icon class="icon" name="image"></ax-icon>
</ax-image-source>
<p>{{ 'label.import.source' | translate }}: {{ name }}</p>
